import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { HeartHandshake, Loader2 } from "lucide-react";
import { api } from "@/lib/api";

export default function DonateSuccess() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const [status, setStatus] = useState("checking");
  const [amount, setAmount] = useState(0);
  const sid = params.get("session_id");

  useEffect(() => {
    if (!sid) { setStatus("error"); return; }
    let tries = 0;
    const poll = async () => {
      try {
        const { data } = await api.get(`/donations/status/${sid}`);
        if (data.payment_status === "paid") { setAmount(data.amount); setStatus("paid"); return; }
      } catch {}
      if (tries++ < 10) setTimeout(poll, 2000); else setStatus("timeout");
    };
    poll();
  }, [sid]);

  return (
    <div style={{ background: "#1e2130" }} className="flex min-h-screen flex-col items-center justify-center px-5 text-center text-[#faf6f0]">
      {status === "checking" && <><Loader2 className="animate-spin text-[#f76359]" size={44} /><p className="mt-4">Confirming your gift…</p></>}
      {status === "paid" && (
        <div>
          <HeartHandshake size={54} className="mx-auto text-[#f76359]" />
          <h1 className="mt-4 text-2xl font-extrabold">Thank you for your gift!</h1>
          <p className="mt-2 text-[#faf6f0]/75">Your ${(amount / 100).toFixed(2)} gift is received. A thank-you receipt has been recorded.</p>
          <p className="mt-1 text-xs text-amber-300">Stripe TEST mode — no live charge.</p>
          <button onClick={() => nav("/plaza")} className="mt-6 rounded-full bg-[#f76359] px-6 py-3 font-semibold text-white">Back to the Plaza</button>
        </div>
      )}
      {["error", "timeout"].includes(status) && <><h1 className="text-2xl font-extrabold">Gift not confirmed</h1><button onClick={() => nav("/plaza")} className="mt-6 rounded-full bg-[#f76359] px-6 py-3 font-semibold text-white">Back</button></>}
    </div>
  );
}
